import { render, staticRenderFns } from "./base-select.vue?vue&type=template&id=1d4eb65b&scoped=true"
import script from "./base-select.vue?vue&type=script&lang=ts"
export * from "./base-select.vue?vue&type=script&lang=ts"
import style0 from "./base-select.vue?vue&type=style&index=0&id=1d4eb65b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4eb65b",
  null
  
)

export default component.exports